export default {
  pedidos: [],
  totalPedidos: 0,
  categorias: [],
  productos: [],
  estados: [
    {
      value: 'realizando',
      text: 'Realizando el franquiciado'
    },
    {
      value: 'espera',
      text: 'En espera'
    },
    {
      value: 'preparando',
      text: 'Preparando'
    },
    {
      value: 'enviado',
      text: 'Enviado por la central'
    }
  ],
  estadoFiltrar: ['espera', 'enviado', 'finalizado']
}